import React from 'react';
import language from '../../config/es';

const LabelTitle = (props) => {
   
  const { text = "", requerid=false } = props;

  return (
    <label className="text-muted small text-uppercase">
      {text}
      <span className={requerid?"text-danger":"noDisplay"}>{language.messages.caracter}</span>
    </label>
  );
};

export default LabelTitle;
